import React, {useRef} from 'react';
import Dropdown, {DropdownButton, DropdownMenu} from '../dropdown/dropdown';
import OverflowMenu from '../overflowMenu/overflowMenu';
import Avatar from '../avatar/avatar';


type OverrideStyles = {
  [key: string]: any;
};

interface IUpperMenu {
  /**
   * For setting the Avatar info
   */
  avatar: React.ReactComponentElement<typeof Avatar>;
  /**
   * Title of the Upper Menu
   */
  title?: string;
  /**
   * Overflow menu in notification center, items could be any.
   * By default badge show the lenght of items, if you need to edit it, set counter number
   */
  notifications?: {
    onVisibilityChange: () => void;
    onAction?: () => void;
    action?: string;
    emptyMessage?: string;
    title: string;
    items: React.ReactElement[];
    counter?: number;
    showItems: boolean;
    showCloseButton?: boolean;
  };
  /**
   * Options of the Upper Menu
   */
  options?: {name: React.ReactNode; onClick: () => void}[];
  className?: string;
    // /**
  //  * override styles. You need to pass an object with css properties in camelCase
  //  */
  overrideStyles?: OverrideStyles;
  // /**
  //  * if you need the dropdown to render as a portal you should use this prop
  //  */
  renderAsPortal?: boolean,
   // /**
  //  * if you need the dropdown placement you should use this prop
  //  */
  dropDownPlacement?: any,
  [others: string]: any;
}

const UpperMenu: React.FC<IUpperMenu> = ({avatar, title, notifications, options, className, renderAsPortal = false, overrideStyles = null, dropDownPlacement= null, ...rest}) => {
  const notifButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <div
      className={`upper-menu ${className || ''}`}
      data-testid={rest && rest['data-testid'] ? rest['data-testid'] : undefined}
      {...rest}
    >
      {title && (
        <div
          className="upper-menu_left"
          data-testid={rest && rest['data-testid'] ? rest['data-testid'] + '-title' : undefined}
        >
          {title}
        </div>
      )}
      <div className="upper-menu_right">
        {notifications && (
          <div className="upper-menu-notifications">
            <button
              type="button"
              ref={notifButtonRef}
              className="upper-menu-icon"
              onClick={notifications.onVisibilityChange}
              data-testid={rest && rest['data-testid'] ? rest['data-testid'] + '-notif-icon' : undefined}
            >
              {(notifications.counter || notifications.items.length > 0) && (
                <div className="badge_small">{notifications.counter ?? notifications.items.length}</div>
              )}
              <span className="material-icons">notifications</span>
            </button>
            <OverflowMenu
              show={notifications.showItems}
              className="upper-menu-overflow notification-center"
              title={notifications.title}
              onClose={notifications.onVisibilityChange}
              action={notifications.action}
              onAction={notifications.onAction}
              parentRef={notifButtonRef}
            >
              {notifications.items.length > 0 ? notifications.items : notifications.emptyMessage}
            </OverflowMenu>
          </div>
        )}
        {avatar}
        {options && options.length > 0 && (
          <Dropdown id="upper-menu-options" className="upper-menu-dropdown">
            <DropdownButton>
              <button
                type="button"
                className="upper-menu-info"
                data-testid={rest && rest['data-testid'] ? rest['data-testid'] + '-more-info' : undefined}
              >
                <span className="material-icons">more_vert</span>
              </button>
            </DropdownButton>
            <DropdownMenu renderAsPortal={renderAsPortal} placement={dropDownPlacement} overrideStyles={overrideStyles}  >
              <ul>
                {options.map(({name, onClick}, idx) => (
                  <li className="dropdown-item" onClick={onClick} key={idx + '-upper-menu-dropdown'}>
                    {name}
                  </li>
                ))}
              </ul>
            </DropdownMenu>
          </Dropdown>
        )}
      </div>
    </div>
  );
};
export default UpperMenu;
